import { render, staticRenderFns } from "./icon-customer-light-user-tag-chat.vue?vue&type=template&id=2b7b29a4&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports